/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __extends } from "tslib";
import { objectForEach } from '../../mol-util/object';
import { RepresentationRegistry } from '../representation';
import { BallAndStickRepresentationProvider } from './representation/ball-and-stick';
import { CarbohydrateRepresentationProvider } from './representation/carbohydrate';
import { CartoonRepresentationProvider } from './representation/cartoon';
import { EllipsoidRepresentationProvider } from './representation/ellipsoid';
import { GaussianSurfaceRepresentationProvider } from './representation/gaussian-surface';
import { LabelRepresentationProvider } from './representation/label';
import { MolecularSurfaceRepresentationProvider } from './representation/molecular-surface';
import { OrientationRepresentationProvider } from './representation/orientation';
import { PointRepresentationProvider } from './representation/point';
import { PuttyRepresentationProvider } from './representation/putty';
import { SpacefillRepresentationProvider } from './representation/spacefill';
import { LineRepresentationProvider } from './representation/line';
import { GaussianVolumeRepresentationProvider } from './representation/gaussian-volume';
import { BackboneRepresentationProvider } from './representation/backbone';

var StructureRepresentationRegistry =
/** @class */
function (_super) {
  __extends(StructureRepresentationRegistry, _super);

  function StructureRepresentationRegistry() {
    var _this = _super.call(this) || this;

    objectForEach(StructureRepresentationRegistry.BuiltIn, function (p, k) {
      if (p.name !== k) throw new Error("Fix BuiltInStructureRepresentations to have matching names. " + p.name + " " + k);

      _this.add(p);
    });
    return _this;
  }

  return StructureRepresentationRegistry;
}(RepresentationRegistry);

export { StructureRepresentationRegistry };

(function (StructureRepresentationRegistry) {
  StructureRepresentationRegistry.BuiltIn = {
    'cartoon': CartoonRepresentationProvider,
    'backbone': BackboneRepresentationProvider,
    'ball-and-stick': BallAndStickRepresentationProvider,
    'carbohydrate': CarbohydrateRepresentationProvider,
    'ellipsoid': EllipsoidRepresentationProvider,
    'gaussian-surface': GaussianSurfaceRepresentationProvider,
    'gaussian-volume': GaussianVolumeRepresentationProvider,
    'label': LabelRepresentationProvider,
    'line': LineRepresentationProvider,
    'molecular-surface': MolecularSurfaceRepresentationProvider,
    'orientation': OrientationRepresentationProvider,
    'point': PointRepresentationProvider,
    'putty': PuttyRepresentationProvider,
    'spacefill': SpacefillRepresentationProvider
  };
})(StructureRepresentationRegistry || (StructureRepresentationRegistry = {}));